export default __webpack_public_path__ + "static/media/bajookieland-purchase.6d3b8600.jpg";